import { Scope } from '@pubstack/common/src/scope'
import { FunctionComponent } from 'react'
import { BeamerIntegration } from '~/components/layout/BeamerIntegration'
import { ProductTrackingIntegration } from './ProductTrackingIntegration'

export const ProductIntegration: FunctionComponent<{ scopes: Scope[] }> = ({ scopes }) => {
  if (!scopes) return null

  return (
    <>
      <ProductTrackingIntegration />
      <BeamerIntegration scopes={scopes} />
    </>
  )
}
